import type { CityConfig } from "../city-template/types";

export const southfieldConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Oakland County Clerk", href: "https://www.oakgov.com/clerkrod/", description: "Oakland County Clerk — marriage license issuance" },
    { label: "Divorce Records — Oakland County Clerk", href: "https://www.oakgov.com/clerkrod/", description: "Oakland County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Southfield",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "southfield",
  route: "/southfield",
  title: "Emergency Passport Southfield, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Southfield, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Southfield, Lathrup Village, Beverly Hills, Franklin, Bingham Farms, and all Oakland County residents. Detroit Passport Agency courier. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Southfield, MI",
  heroSubtitle: "Southfield travelers — from the Oakland County business district to the Providence Hospital corridor to the diverse residential communities — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. Detroit Passport Agency is just 20 minutes south. A+ BBB rated courier service serving all of Oakland County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Modern%20Southfield%20Michigan%20skyline%20with%20the%20Southfield%20Town%20Center%20office%20towers%20rising%20above%20the%20suburban%20landscape%2C%20wide%20avenue%20view%20with%20professional%20office%20buildings%2C%20green%20trees%20and%20well-maintained%20landscaping%2C%20warm%20afternoon%20light%20with%20blue%20sky%2C%20urban%20business%20district%20in%20suburban%20Detroit%20setting%2C%20no%20text%20no%20people%2C%20photorealistic%20architectural%20photography%20with%20warm%20earth%20tones%20and%20muted%20sky&width=1800&height=700&seq=southfield-hero-001&orientation=landscape",
  heroImageAlt: "Southfield Michigan skyline with Southfield Town Center office towers and suburban business district",
  geoPosition: "42.4734;-83.2218",
  geoPlacename: "Southfield, Michigan",
  lastModified: "2026-06-01",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 20–25 minutes south via I-696 or the Lodge Freeway — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Southfield", zips: "48033, 48034, 48075, 48076" },
    { name: "Lathrup Village", zips: "48076" },
    { name: "Beverly Hills", zips: "48025" },
    { name: "Franklin", zips: "48025" },
    { name: "Bingham Farms", zips: "48025" },
    { name: "Oak Park", zips: "48237" },
    { name: "Ferndale", zips: "48220" },
    { name: "Huntington Woods", zips: "48070" },
    { name: "Pleasant Ridge", zips: "48069" },
    { name: "Royal Oak", zips: "48067, 48068, 48073" },
    { name: "Berkley", zips: "48072" },
    { name: "Troy", zips: "48083, 48084, 48085, 48098" },
    { name: "Farmington Hills", zips: "48331, 48333, 48334, 48335, 48336" },
    { name: "Novi", zips: "48374, 48375, 48377" },
    { name: "West Bloomfield", zips: "48322, 48323, 48324, 48325" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-2-line", title: "Southfield Business District", desc: "Serving Oakland County professionals and corporate travelers with discretion" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — stay home while we do the work" },
  ],
  internalLinks: [
    { name: "Expedited passport in Detroit, MI", route: "/detroit" },
    { name: "Emergency passport services in Troy, MI", route: "/troy-mi" },
    { name: "Urgent passport services in Pontiac, MI", route: "/pontiac" },
    { name: "Michigan passport services overview", route: "/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Southfield, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Southfield residents can ship from any UPS or FedEx in Oakland County.",
  fpcOfficeDistance: "Serving Southfield, Lathrup Village, Beverly Hills, Franklin, Bingham Farms, Oak Park, Ferndale, Huntington Woods, Pleasant Ridge, Royal Oak, Berkley, Troy, Farmington Hills, Novi, and West Bloomfield",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Southfield and the greater Oakland County area. From the Southfield Town Center business district to the Providence Hospital corridor to the Telegraph Road corridor — we serve all of Southfield and the surrounding Oakland County communities. Southfield is the northern business hub of Metro Detroit, and our couriers have direct access to the Detroit Passport Agency just 20 minutes south.",
  nearbyCitiesIntro: "We serve Southfield and all surrounding Oakland County communities including Lathrup Village, Beverly Hills, Franklin, Bingham Farms, Oak Park, Ferndale, Huntington Woods, Pleasant Ridge, Royal Oak, Berkley, Troy, Farmington Hills, Novi, and West Bloomfield. We also serve neighboring Wayne and Macomb counties.",
  howItWorksIntro: "Most Southfield travelers complete everything online and ship documents overnight. No waiting weeks for a passport agency appointment — our registered couriers handle the Detroit Passport Agency submission for you.",
  mistakesIntro: "Southfield is a major business and professional community with many corporate travelers and families. Here are the most common passport mistakes we see from Southfield and Oakland County travelers.",
  testimonialsIntro: "Southfield travelers — from corporate executives to healthcare professionals to families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Southfield, MI? Here are the most common ones we hear from Oakland County travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for business and corporate travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person downtown Detroit", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Southfield travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute business trips, corporate emergencies, and international travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "Corporate and business travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Southfield adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Southfield address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Southfield residents and families — including young professionals, new families, and Oakland County residents applying for their first passport.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Southfield residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Southfield-area families planning international vacations or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Southfield and Oakland County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Southfield MI", description: "Urgent passport processing for Southfield Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Southfield MI", description: "Fast passport renewal for Southfield Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Southfield MI", description: "New passport application services for Southfield Michigan residents applying for their first passport." },
    { name: "Child Passport Southfield MI", description: "Minor passport services for Southfield Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Dr. Angela W.",
      location: "Southfield, MI",
      rating: 5,
      text: "Medical conference in London in 4 days and my passport was expired. Fast Passport Center handled the renewal in 36 hours. I shipped from the UPS on Telegraph and had my passport before the conference. Absolutely essential service.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Brian C.",
      location: "Farmington Hills, MI",
      rating: 5,
      text: "Corporate merger required immediate travel to Frankfurt. Fast Passport Center got me an emergency passport in 2 days. The process was completely discreet and professional.",
      service: "Emergency Passport",
    },
    {
      name: "Rachel M.",
      location: "Southfield, MI",
      rating: 5,
      text: "Family trip to Israel with 8 days notice. Five passports for our family. Done in 5 days. We shipped from the FedEx on Southfield Road and everything went perfectly.",
      service: "Family Passport Bundle",
    },
    {
      name: "David S.",
      location: "Beverly Hills, MI",
      rating: 5,
      text: "Realized my passport was expiring the day before my flight to Tokyo. Fast Passport Center got me a renewed passport in 24 hours. The courier service is a game-changer for business travelers.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "southfield-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "230 S Dearborn St, Suite 380",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 20–25 minutes south of Southfield via I-696 or the Lodge Freeway",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "southfield-2",
      name: "Southfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "22200 W 11 Mile Rd",
      city: "Southfield",
      state: "MI",
      zip: "48034",
      phone: "(248) 355-6660",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Southfield — near 11 Mile and Telegraph",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Southfield acceptance facility. Convenient for residents along the Telegraph and Southfield corridors. Appointments required — book 1–2 weeks in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "southfield-3",
      name: "Royal Oak Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 W 5th St",
      city: "Royal Oak",
      state: "MI",
      zip: "48067",
      phone: "(248) 549-6460",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Royal Oak — approximately 5 miles east of Southfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Southfield and Royal Oak residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "southfield-4",
      name: "Farmington Hills Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "31105 W 12 Mile Rd",
      city: "Farmington Hills",
      state: "MI",
      zip: "48334",
      phone: "(248) 476-3670",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Farmington Hills — approximately 8 miles west of Southfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves western Southfield and Farmington Hills residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "southfield-5",
      name: "Troy Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2844 Crooks Rd",
      city: "Troy",
      state: "MI",
      zip: "48084",
      phone: "(248) 649-3410",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Troy — approximately 10 miles north of Southfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northern Southfield and Troy residents. Book early — high demand during summer.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in Southfield" },
    { feature: "Corporate Travel Expertise", agency: "No tailored advice", fpc: "Yes — serving Oakland County business professionals" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Southfield business professionals and families often discover passport issues right before planned travel. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for Air Travel",
      description: "Many Southfield residents use a passport card for land crossings to Canada — but these are not valid for air travel. If you fly internationally, you need a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Southfield-area acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Business Visa Requirements",
      description: "Southfield corporate travelers should verify business visa requirements in addition to passport validity. Many countries require separate business visas that take additional processing time.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Southfield or Oakland County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Southfield or Oakland County." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Southfield address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the Detroit Passport Agency from Southfield?", a: "The Detroit Passport Agency is located at 230 S Dearborn St, Suite 380, Chicago, IL 60604, approximately 20–25 minutes south of Southfield via I-696 or the Lodge Freeway. It is open Monday through Friday 8:00 AM – 3:00 PM by appointment only. Appointments are typically booked 2 weeks out. Fast Passport Center's registered couriers have direct access to submit applications without individual appointments." },
    { q: "How fast can I get an emergency passport in Southfield?", a: "Fast Passport Center offers emergency passport processing in Southfield, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to take a day off work or drive to downtown Detroit." },
    { q: "Can I get an expedited passport in Southfield suburbs like Farmington Hills, Beverly Hills, or Oak Park?", a: "Absolutely. Fast Passport Center serves all of Oakland County including Southfield, Lathrup Village, Beverly Hills, Franklin, Bingham Farms, Oak Park, Ferndale, Huntington Woods, Pleasant Ridge, Royal Oak, Berkley, Troy, Farmington Hills, Novi, and West Bloomfield. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do Southfield-area travelers use for international flights?", a: "Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international departure hub for Southfield and Oakland County travelers. DTW is approximately 30–40 minutes from Southfield via I-696 and I-94. It offers direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and dozens of other international destinations. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Southfield, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Southfield residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Southfield and Oakland County offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve the Upper Peninsula of Michigan?", a: "Yes. Fast Passport Center's courier service is especially valuable for Upper Peninsula residents, who would otherwise face an 8+ hour drive to the Detroit Passport Agency. We serve Marquette, Sault Ste. Marie, Escanaba, Houghton, and all UP communities — you just ship your documents overnight and we handle everything from there." },
    { q: "What is the best way for Southfield residents to get to the Detroit Passport Agency?", a: "The fastest route from Southfield to the Detroit Passport Agency is south on the Lodge Freeway (M-10) or I-696 to I-75, then to downtown Detroit at 211 W. Fort St in the Patrick V. McNamara Federal Building. The drive is approximately 20–25 minutes. However, you don't need to go there yourself — Fast Passport Center's registered couriers handle the in-person submission for you. You simply ship your documents from any UPS or FedEx in Southfield or Oakland County." },
  ],
  photoLocations: [
    { name: "Walgreens — Southfield 12 Mile", address: "21600 W 12 Mile Rd, Southfield, MI 48076", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Southfield Telegraph", address: "25250 Telegraph Rd, Southfield, MI 48033", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Southfield", address: "22200 W 11 Mile Rd, Southfield, MI 48034", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Troy", address: "675 E Big Beaver Rd, Troy, MI 48083", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Southfield", address: "17500 W 10 Mile Rd, Southfield, MI 48075", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Serves Southfield and central Oakland County. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Farmington Hills", address: "31155 W 12 Mile Rd, Farmington Hills, MI 48334", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Farmington Hills, Novi, and western Oakland County communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "30–40 minutes from Southfield via I-696 and I-94",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for Southfield and Oakland County travelers. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Largest airport in Michigan.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
    {
      code: "PTK",
      name: "Oakland County International Airport",
      distance: "15–20 minutes from Southfield — charter and private only",
      address: "6500 Highland Rd, Waterford, MI 48327",
      note: "Smaller regional airport primarily for charter and private flights. Not used for commercial international travel. DTW remains the main gateway for international departures.",
      flightUrl: "https://www.oakgov.com/aviation/",
      flightLabel: "Oakland County Airport Info",
      featured: false,
    },
  ],
};